import SearchIcon from "@mui/icons-material/Search";

import { Autocomplete } from "@/Components/v2/atoms/Autocomplete";
import { Typography } from "@/Components/v2/atoms/Typography";
import { Option } from "@/Components/v2/molecule/LabelledAutoComplete/types";

import { Stack } from "../../atoms/Stack";
import { TextField } from "../../atoms/TextField";

interface LabelledComboBoxProps {
  label: string;
  id: string;
  options: Option[];
  selectedOption: Option | null;
  onSelectChange: (selected: Option) => void;
  groupBy?: (option: Option) => string;
  disabled?: boolean;
  disableClearable?: boolean;
  width?: number;
}

export const LabelledComboBox: React.FC<LabelledComboBoxProps> = ({
  label,
  id,
  selectedOption,
  onSelectChange,
  options,
  disableClearable,
  disabled,
  groupBy = () => "",
  width = 300,
}) => {
  const handleSelection = (selected: Option) => {
    if (selected === null || selected === undefined) {
      return;
    }
    onSelectChange(selected);
  };

  const getOptionLabel = (option: Option) => {
    return option.label;
  };

  if (!options || options.length === 0) {
    return (
      <Stack>
        <Typography variant="body1" mb={1} fontWeight={600}>
          {label}
        </Typography>
        <TextField
          disabled
          fullWidth
          size="small"
          placeholder="No Data"
          InputProps={{
            startAdornment: <SearchIcon style={{ marginRight: 4 }} />,
          }}
        />
      </Stack>
    );
  }

  return (
    <Stack>
      <Typography variant="body1" mb={1} fontWeight={600}>
        {label}
      </Typography>
      <Autocomplete
        disabled={!!disabled}
        disablePortal
        disableClearable={disableClearable}
        id={id}
        options={options}
        getOptionLabel={getOptionLabel}
        groupBy={groupBy}
        onChange={(_, value) => handleSelection(value)}
        value={selectedOption}
        sx={{ width: width }}
        renderInput={(params) => (
          <TextField
            {...params}
            id={id}
            placeholder={`Select ${label}`}
            InputProps={{
              ...params.InputProps,
              startAdornment: <SearchIcon />,
            }}
            fullWidth
            size="small"
            InputLabelProps={{}}
          />
        )}
      />
    </Stack>
  );
};

export default LabelledComboBox;
